import { type AnyAction, type Dispatch, type Middleware, type MiddlewareAPI } from 'redux';
import queryString from 'query-string';
import { get, size, some } from 'lodash';
import { UPDATE_FILTER } from '../actions/actionTypes/filters';
import { filterIds, mapViewAndGroupValues } from '../../utils/filters';
import { history } from '../history';
import { PAGES } from '../../utils/pages';
import { type RootState } from '../types';

const synchronizedFilterIds: Record<string, string[]> = {
    [PAGES.DASHBOARD]: [filterIds.datesFilter, filterIds.agentsCommonDashboardFilter, filterIds.dashboardCardFilter],
    [PAGES.REPORTS]: [
        filterIds.datesFilter,
        filterIds.reportGranularityFilter,
        filterIds.reportTypeFilter,
        filterIds.reportViewFilter,
        filterIds.reportAgentsFilter,
        filterIds.reportTabGroupFilter
    ]
};

export const dateFilterUrlParams = {
    dateFrom: 'from',
    dateTo: 'to'
};

export const urlParamsSynchronizer: Middleware =
    (store: MiddlewareAPI<Dispatch<AnyAction>, RootState>) => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
        const { type, payload, meta } = action;

        if (type === UPDATE_FILTER) {
            if (
                some(Object.keys(synchronizedFilterIds), key => synchronizedFilterIds[key].includes(payload.filterId))
            ) {
                const queryParams = queryString.parse(history.location.search);
                if (payload.filterId === filterIds.datesFilter) {
                    queryParams[dateFilterUrlParams.dateFrom] = JSON.stringify(payload.value.from);
                    queryParams[dateFilterUrlParams.dateTo] = JSON.stringify(payload.value.to);
                } else {
                    if (payload.filterId === filterIds.reportViewFilter && size(payload.value.subvalues) > 0) {
                        queryParams[filterIds.reportTabGroupFilter] = JSON.stringify(
                            mapViewAndGroupValues(payload.value.value)
                        );
                    }
                    queryParams[payload.filterId] = JSON.stringify(payload.value);
                }

                history.replace({
                    ...history.location,
                    search: queryString.stringify(queryParams)
                });
            }
        } else if (meta?.location && meta.location.kind !== 'load') {
            // Sync params in url from store on Route change

            let queryParams: any = meta.query || {};
            const currentType = get(meta.location, 'current.type', '');
            const filtersToSync = get(synchronizedFilterIds, currentType, []);

            filtersToSync.forEach(filterId => {
                const filterValue = get(store.getState(), `filters.${filterId}`);
                if (filterId === filterIds.datesFilter) {
                    queryParams = {
                        ...queryParams,
                        [dateFilterUrlParams.dateFrom]: JSON.stringify(filterValue.from),
                        [dateFilterUrlParams.dateTo]: JSON.stringify(filterValue.to)
                    };
                } else {
                    queryParams[filterId] = JSON.stringify(filterValue);
                }
            });
            history.replace({
                ...history.location,
                ...meta.location.current,
                search: queryString.stringify(queryParams)
            });
        }

        return next(action);
    };
